import { render, staticRenderFns } from "./LeadDuplicates.vue?vue&type=template&id=92f64570&"
import script from "./LeadDuplicates.vue?vue&type=script&lang=js&"
export * from "./LeadDuplicates.vue?vue&type=script&lang=js&"
import style0 from "./LeadDuplicates.vue?vue&type=style&index=0&id=92f64570&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports